import cx from 'clsx';
import { type ReactNode, useMemo } from 'react';
import { useIntl } from 'react-intl';
import americanExpressIcon from '../../assets/icons/american-express.png';
import cartesBancairesIcon from '../../assets/icons/cartes-bancaires.png';
import mastercardIcon from '../../assets/icons/mastercard.png';
import visaIcon from '../../assets/icons/visa.png';
import { CardProvider } from '../../constants';
import styles from './credit-card-icons.module.css';

interface CreditCardIconsProps {
  className?: string;
  providers?: CardProvider[];
}

const DEFAULT_PROVIDERS: CardProvider[] = [
  CardProvider.Visa,
  CardProvider.Mastercard,
  CardProvider.CartesBancaires,
  CardProvider.AmericanExpress,
];

export function CreditCardIcons({
  className,
  providers = DEFAULT_PROVIDERS,
}: CreditCardIconsProps): ReactNode {
  const { formatMessage } = useIntl();

  const config = useMemo(
    () => ({
      visa: {
        imagePath: visaIcon,
        ariaLabel: formatMessage({
          id: 'shared-kit.credit-card-icons.visa-aria-label',
        }),
      },
      mastercard: {
        imagePath: mastercardIcon,
        ariaLabel: formatMessage({
          id: 'shared-kit.credit-card-icons.mastercard-aria-label',
        }),
      },
      american_express: {
        imagePath: americanExpressIcon,
        ariaLabel: formatMessage({
          id: 'shared-kit.credit-card-icons.american-express-aria-label',
        }),
      },
      cartes_bancaires: {
        imagePath: cartesBancairesIcon,
        ariaLabel: formatMessage({
          id: 'shared-kit.credit-card-icons.cartes-bancaires-aria-label',
        }),
      },
    }),
    [formatMessage]
  );

  return (
    <div className={cx(className, styles.icons)}>
      {providers.map(provider => {
        const { imagePath, ariaLabel } = config[provider];
        return <img alt={ariaLabel} key={provider} src={imagePath} />;
      })}
    </div>
  );
}
